import React, { useEffect } from "react";
import { X } from "lucide-react";

/**
 * Lightweight YouTube popup. Pass `videoId` + `open` + `onClose`.
 */
export default function VideoModal({ open, onClose, videoId, title = "Stori demo" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid="video-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/85 backdrop-blur-md"
      onClick={onClose}
    >
      <button
        aria-label="Close video"
        data-testid="video-modal-close"
        className="absolute top-6 right-6 w-11 h-11 rounded-full border border-stori-border text-white hover:border-stori-cyan hover:text-stori-cyan transition-colors flex items-center justify-center"
        onClick={onClose}
      >
        <X className="w-5 h-5" />
      </button>
      <div
        className="w-full max-w-5xl aspect-video rounded-xl overflow-hidden border border-stori-border bg-black"
        onClick={(e) => e.stopPropagation()}
      >
        <iframe
          title={title}
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
          style={{ border: 0 }}
        />
      </div>
    </div>
  );
}
